import { linear, type EasingFunction } from "./easingFunctions";

export class Tween {
  private elapsedSeconds = 0;

  private readonly durationSeconds: number;
  private readonly easingFunction: EasingFunction;

  constructor(
    durationSeconds: number,
    easingFunction: EasingFunction = linear
  ) {
    this.durationSeconds = durationSeconds;
    this.easingFunction = easingFunction;
  }

  step(deltaSeconds: number) {
    this.elapsedSeconds = Math.min(this.elapsedSeconds + deltaSeconds, this.durationSeconds);
  }

  get progress(): number {
    return this.easingFunction(this.elapsedSeconds / this.durationSeconds);
  }

  get isFinished(): boolean {
    return this.elapsedSeconds >= this.durationSeconds;
  }
}
